__turbopack_context__.v({
  "content": "Hero-module__Wbzt0q__content",
  "imageContainer": "Hero-module__Wbzt0q__imageContainer",
  "root": "Hero-module__Wbzt0q__root",
});
